import React from 'react'
import image from './../images/Launch Call to Action Section.png'
import Navbar from '../components/Navbar'
import FAQs from '../components/FAQs'
import Footer from '../components/Footer'

function Faqs() {
    return (
        <main className="main" id="top">
            <Navbar />
            <section className="position-relative vw-100" style={{height: 400}} id="home">
                <div className="position-absolute w-100 h-100" style={{backgroundImage: `url('${image}')`, backgroundPosition: "top", backgroundSize: "cover", backgroundRepeat: "no-repeat",  top: 0, left: 0, zIndex: -1, filter: "brightness(0.35)"}}>
                </div>
            </section>
            <section className="position-relative p-lg-3" id="faqs">
                <FAQs />
            </section>
            <Footer />
        </main>
    )
}

export default Faqs
